import { dateTimeFormatFr, dateTimeFormatFrLong } from '@/utils/data/date'
import { userName } from '@/utils/data/agents'

export const CONTRACT_STATUS_ACTIVE = 100
export const CONTRACT_STATUS_PENDING = 200
export const CONTRACT_STATUS_SIGNED = 300
export const CONTRACT_STATUS_ARCHIVED = 400
export const CONTRACT_PRICE_SIGNATURE_STR = '0,90€'

export const CONTRACT_TYPES_CUSTOMER = 'customer'
export const CONTRACT_TYPES_AGENT = 'agent'

export const CONTRACT_STATUS_LIST = [
  {
    value: CONTRACT_STATUS_ACTIVE,
    slug: CONTRACT_STATUS_ACTIVE,
    label: 'Créé',
    signLabel: 'Non demandée',
    color: 'positive'
  },
  {
    value: CONTRACT_STATUS_PENDING,
    slug: CONTRACT_STATUS_PENDING,
    label: 'En attente de signature',
    signLabel: 'En attente',
    color: 'warning'
  },
  {
    value: CONTRACT_STATUS_SIGNED,
    slug: CONTRACT_STATUS_SIGNED,
    label: 'Signé',
    signLabel: 'Signé',
    color: 'accent'
  },
  {
    value: CONTRACT_STATUS_ARCHIVED,
    slug: CONTRACT_STATUS_ARCHIVED,
    label: 'Archivé',
    signLabel: 'Document supprimé',
    color: 'negative'
  }
]

export const CONTRACT_ACTIVE_STATUS = [
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_STATUS_PENDING,
  CONTRACT_STATUS_SIGNED
]

export const CONTRACT_STATUS = _.keyBy(CONTRACT_STATUS_LIST, 'value')

export const DATA_AGENCY_CONTRACT_PERSISTANCE_KEY = 'AgencyContract'
export const DATA_AGENCY_CONTRACT_COLUMNS = [
  {
    name: 'createdAt',
    field: 'createdAt',
    label: 'Date de création',
    sortable: true,
    format: (v) => dateTimeFormatFr(v),
    classes: 'sticky',
    headerClasses: 'sticky'
  },
  {
    contractTypes: [CONTRACT_TYPES_AGENT],
    name: 'agent',
    field: 'agent',
    label: 'Agent',
    sortable: true,
    format: (agent = {}) => userName(agent)
  },
  {
    contractTypes: [CONTRACT_TYPES_CUSTOMER],
    name: 'customer',
    field: 'customer',
    label: 'Client',
    sortable: true,
    format: (customer = {}) => customer.name
  },
  {
    name: 'updatedAt',
    field: 'updatedAt',
    label: 'Date de modification',
    sortable: true,
    format: (v) => dateTimeFormatFr(v)
  },
  {
    name: 'title',
    field: 'title',
    label: 'Titre'
  },
  {
    name: 'status',
    field: 'status',
    label: `Status`,
    sortable: true
  },
  {
    name: 'signatures',
    field: 'signatures',
    label: `Signature électronique`,
    sortable: true,
    format: (signatures = [], row = {}) => signatures.length
      ? signatures.map(
        ({
          fullname,
          signedAtDate
        }) => signedAtDate
          ? {
            label: `${fullname} le ${dateTimeFormatFrLong(signedAtDate)}`
          }
          : {
            type: 'badge',
            color: 'warning',
            label: 'En attente de signature'
          }
      )
      : [
        {
          label: ((CONTRACT_STATUS[row.status] && CONTRACT_STATUS[row.status].signLabel) || 'Non demandée')
        }
      ]
  }
]

export const DATA_AGENCY_CONTRACT_INDEXED_COLUMNS = _.keyBy(DATA_AGENCY_CONTRACT_COLUMNS, 'name')

export const CONTRACT_LOAD_GET_MODELS = 'Récupération des modèles.'
export const CONTRACT_SIGN_SUCCESS = 'Contrat signé.'
export const LOADING_SIGN_FETCH = 'Récupération de la signature.'
export const LOADING_CONTRACT_FETCH = 'Récupération du contrat.'
export const CONTRACT_SIGN_NOT_FOUND = 'Signature introuvable.'
export const CONTRACT_DELETE_ERROR = 'Une erreur c\'est produite pendant la suppression du contrat.'
export const CONTRACT_SIGN_ERROR = 'Une erreur c\'est produite pendant la signature.'
export const CONTRACT_NOT_FOUND = 'Contrat introuvable.'
export const CONTRACT_SENDER_ALREADY_SIGNED = `Vous avez déjà signé le contrat.`
export const CONTRACT_RECEIVER_ALREADY_SIGNED = `Contrat déjà signé.`
export const CONTRACT_CHECK_CONDITIONS = `Bon pour accord sur l’ensemble des éléments mentionnés au présent contrat.`
export const DIALOG_SIGNATURE_VALIDATION_CONDITIONS = 'En validant la signature électronique du contrat, vous en acceptez les ' +
  'conditions.\nUn accusé de réception contenant le contrat signé au format pdf vous parviendra par email,\n ainsi qu’à l’expéditeur.'

export const GET_DIALOG_SENDER = (signPrice) =>
  `Vous demandez la signature électronique du contrat. Le cout d’une signature électronique est de ${signPrice} ht.`

export const GET_CONTRACT_MODEL_VARIABLES_HELP = (name, email) =>
  `Vous avez la possibilité d'ajouter des "variables" dans le modèle,
les variables seront remplacées lors de la création du contrat par les données exigées.<br><br>
Par exemple pour avez besoin de la <b><i>Nationalité de l'agent</i></b>, il vous suffit de placer la variable
"<b><i>Nationalité de l'agent</i></b>" depuis le menu déroulent
<b>"<u>Variables</u>" > "<u>Agent</u>" > "<u>Nationalité de l'agent</u>"</b>.<br>
Quand le contrat sera généré depuis le modèle, la nationalité de l'agent viendra remplacer la variable.<br><br>
Pour tout renseignement, votre équipe ${name} est joignable par email à l’adresse ${email}.`

/**
 * @param {string} receiverEmail
 * @param {string} signPrice
 * @param {string} receiverBefore - à {{email}}
 * @returns {string}
 */
export const GET_DIALOG_RECEIVER = (receiverEmail = 'client', signPrice = CONTRACT_PRICE_SIGNATURE_STR, receiverBefore = 'à') =>
  `Vous demandez la signature électronique du contrat. Ce dernier sera adressé électroniquement par
  email ${receiverBefore} ${receiverEmail}. Après signature, vous recevrez un accusé de réception par email
  contenant au format pdf le contrat signé.`

export const generateAddressToken = (prefix = 'company.address', subject = `de l'agence`) => ([
  {
    value: `${prefix}.city`,
    label: `Ville ${subject}`
  },
  {
    value: `${prefix}.country`,
    label: `Pays ${subject}`
  },
  {
    value: `${prefix}.street`,
    label: `Adresse postal ${subject}`
  },
  {
    value: `${prefix}.zipcode`,
    label: `Code postal ${subject}`
  }
])

export const DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT = [
  {
    value: 'company.name',
    label: `Nom de l'agence`
  },
  {
    value: 'company.approvalNumber',
    label: `Numéro d'agrément de l'agence`
  },
  {
    value: 'company.siret',
    label: `Numéro de siret de l'agence`
  },
  {
    value: 'company.phone',
    label: `Numéro de téléphone de l'agence`
  },
  {
    value: 'company.email',
    label: `Adresse mail de l'agence`
  },
  {
    value: 'company.agencySettingsFeature.hoursLimit',
    label: `Heures hebdomadaire de l'agence`
  },
  {
    value: 'company.agencyPricingSettings.nightFactor',
    label: `Majoration de nuit de l'agence`
  },
  {
    value: 'company.agencyPricingSettings.sundayFactor',
    label: `Majoration de dimanche de l'agence`
  },
  {
    value: 'company.agentExportSettings.clothAllowance',
    label: `Prime horaire d'habillage de l'agence`
  },
  {
    value: 'company.agentExportSettings.foodAllowance',
    label: `Prime panier de l'agence`
  },
  {
    value: 'company.currency',
    label: `Device de paiement de l'agence`
  }
]
export const DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER = [
  {
    value: 'company.manager.fullname',
    label: `Nom complet du propriétaire de l'agence`
  },
  {
    value: 'company.manager.firstname',
    label: `Prénom du propriétaire de l'agence`
  },
  {
    value: 'company.manager.lastname',
    label: `Nom du propriétaire de l'agence`
  }
]
export const DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS = generateAddressToken()

export const DATA_CONTRACT_AGENCY_EDITOR_TOKENS_DROPDOWN = {
  label: 'Agence',
  sub: true,
  value: 'company',
  data: [
    {
      label: `Addresse`,
      sub: true,
      value: 'company.address',
      data: DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS
    },
    {
      label: 'Propriétaire',
      sub: true,
      value: 'company.manager',
      data: DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER
    },
    ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT
  ]
}
